<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select
              v-model="searchForm.nursinghomeId"
              style="width: 100%"
              placeholder="服务网点"
              @change="nursinghomeIdChange"
            >
              <el-option
                v-for="item in nursinghomeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备名称" prop="name">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="设备名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备型号" prop="deviceModelName">
            <el-input
              clearable
              v-model="searchForm.deviceModelName"
              placeholder="设备型号"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="使用人" prop="elderlyName">
            <el-input
              clearable
              v-model="searchForm.elderlyName"
              placeholder="使用人"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="设备IMEI" prop="deviceSerial">
            <el-input
              clearable
              v-model="searchForm.deviceSerial"
              placeholder="设备IMEI"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="使用状态" prop="useStatus">
            <el-select
              clearable
              v-model="searchForm.useStatus"
              style="width: 100%"
              placeholder="使用状态"
            >
              <el-option
                v-for="item in deviceStatuseList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="6">
          <el-form-item label="在线状态" prop="onlineStatus">
            <el-select clearable v-model="searchForm.onlineStatus" style="width: 100%" placeholder="在线状态">
              <el-option
                v-for="item in onlineStatusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->

        <el-col :span="12">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button
          v-if="permissionList.addBtn"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="addNursingForm"
        >
          新 增</el-button
        >
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          v-if="scope.row.useStatus != 3 && permissionList.editBtn"
          type="text"
          size="small"
          @click="editRecord(scope.row)"
          >编辑
        </el-button>
        <el-button
          v-if="scope.row.useStatus != 3 && !scope.row.elderlyId && permissionList.bindBtn"
          type="text"
          size="small"
          @click="binding(scope.row)"
          >绑定
        </el-button>
        <el-button
          v-if="scope.row.useStatus != 3 && scope.row.elderlyId && permissionList.unbindBtn"
          type="text"
          size="small"
          @click="unbinding(scope.row)"
          >解绑
        </el-button>
        <el-button
          v-if="scope.row.useStatus != 3 && permissionList.scrapBtn"
          type="text"
          size="small"
          @click="destoryDevice(scope.row)"
          >报废
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permissionList.lvliBtn"
          @click="deviceResume(scope.row)"
          >设备履历
        </el-button>
      </template>
    </avue-crud>

    <hr-dialog
      :title="formModel === 'add' ? '新增' : formModel === 'edit' ? '编辑' : '查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <deviceForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></deviceForm>
      </template>
    </hr-dialog>
    <hr-dialog title="绑定老人" :allowFull="false" width="60%" :visible.sync="bindingVisible">
      <template slot="body">
        <relativePeople
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="bindingVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></relativePeople>
      </template>
    </hr-dialog>
    <hr-dialog title="设备履历" :allowFull="false" width="60%" :visible.sync="deviceResumeVisible">
      <template slot="body">
        <deviceResume
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="deviceResumeVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></deviceResume>
      </template>
    </hr-dialog>
    <hr-dialog title="设备数据" :allowFull="false" width="60%" :visible.sync="braceletInfoVisible">
      <template slot="body">
        <braceletInfo
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="braceletInfoVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></braceletInfo>
      </template>
    </hr-dialog>
    <hr-dialog title="设备数据" :allowFull="false" width="60%" :visible.sync="videoInfoVisible">
      <template slot="body">
        <videoInfo
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="videoInfoVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></videoInfo>
      </template>
    </hr-dialog>
    <hr-dialog title="报废" :allowFull="false" width="60%" :visible.sync="destoryDeviceVisible">
      <template slot="body">
        <destoryDevice
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="destoryDeviceVisible"
          @success="recordSuccess"
          :nursinghomeId="this.searchForm.nursinghomeId"
        ></destoryDevice>
      </template>
    </hr-dialog>
  </basic-container>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getSmartDevicePage, smartDeviceUnbind } from '@/api/nursingHome/elderDevice';
import deviceForm from './deviceForm.vue';
import relativePeople from './relativePeople.vue';
import deviceResume from './deviceResume.vue';
import braceletInfo from './braceletInfo.vue';
import videoInfo from './videoInfo.vue';
import destoryDevice from './destoryDevice.vue';
import { getDictionary } from '@/api/common.js';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import {
  getNursinghome,
  getWristbandPage,
  getDeviceTypeList,
  wristbandRemove,
  deviceStart,
  deviceStop,
} from '../api/serveItemManage';
export default {
  components: {
    searchFromShow,
    deviceForm,
    relativePeople,
    deviceResume,
    braceletInfo,
    destoryDevice,
    videoInfo,
  },
  data() {
    return {
      videoInfoVisible: false,
      destoryDeviceVisible: false,
      braceletInfoVisible: false,
      deviceResumeVisible: false,
      bindingVisible: false,
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        nursinghomeId: '',
        name: '',

        deviceModelName: '',
        elderlyName: '',
        deviceSerial: '',
        useStatus: '',
        onlineStatus: '',
      },

      projectList: [],

      provideList: [
        {
          dickey: '0',
          dicvalue: '购买',
        },
        {
          dickey: '1',
          dicvalue: '免费',
        },
      ],
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '服务网点',
            prop: 'nursinghomeName',
          },
          {
            label: '设备名称',
            prop: 'name',
          },
          {
            label: '设备编号',
            prop: 'code',
          },
          {
            label: '设备IMEI',
            prop: 'deviceSerial',
          },
          {
            label: '设备型号',
            prop: 'deviceModelName',
          },
          {
            label: '设备类型',
            prop: 'deviceTypeName',
          },
          {
            label: '所属设备大类',
            prop: 'deviceCategoryName',
          },

          {
            label: '使用人姓名',
            prop: 'elderlyName',
          },
          {
            label: '使用人联系方式',
            prop: 'elderlyTel',
            width: 110,
          },
          {
            label: '设备使用状态',
            prop: 'useStatusValue',
          },
          {
            label: '所属应用场景',
            prop: 'applicationScene',
            dicUrl: '/api/blade-system/dict/dictionary?code=application_scene',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '安装位置',
            prop: 'installAddr',
            width: 100,
            overHidden: true
          },
          // {
          //   label: '在线状态',
          //   prop: 'onlineStatusValue',
          // },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      nursinghomeIdList: [],
      deviceTypeIdList: [],
      onlineStatusList: [],
      deviceStatuseList: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.elderly_add, false),
        editBtn: this.vaildData(this.permission.elderly_edit, false),
        bindBtn: this.vaildData(this.permission.elderly_bind, false),
        unbindBtn: this.vaildData(this.permission.elderly_unbind, false),
        scrapBtn: this.vaildData(this.permission.elderly_scrap, false),
        lvliBtn: this.vaildData(this.permission.elderly_shebeilvli, false),
        shujuBtn: this.vaildData(this.permission.elderly_shebeishuju, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
  },
  activated() {
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    deviceInfo(row) {
      this.formRow = row;
      if (row.deviceTypeName == '智能摄像头') {
        this.videoInfoVisible = true;
      } else {
        this.braceletInfoVisible = true;
      }
    },
    deviceResume(row) {
      this.formRow = row;
      this.deviceResumeVisible = true;
    },
    destoryDevice(row) {
      this.formRow = row;
      this.destoryDeviceVisible = true;
    },
    binding(row) {
      this.formRow = row;
      this.bindingVisible = true;
    },
    switchFun(id, status) {
      if (status == 1) {
        deviceStart({ id: id }).then((res) => {
          this.$message.success('操作成功！');
          this.onLoad();
        });
      }

      if (status == 2) {
        deviceStop({ id: id }).then((res) => {
          this.$message.success('操作成功！');
          this.onLoad();
        });
      }
    },
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    unbinding(row) {
      this.$confirm(' 是否解绑该设备?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          smartDeviceUnbind(row.id).then((re) => {
            this.$message.success('解绑成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },

    editRecord(row) {
      this.formRow = row;
      this.formModel = 'edit';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.editVisible = false;
      (this.destoryDeviceVisible = false),
        (this.braceletInfoVisible = false),
        (this.deviceResumeVisible = false),
        (this.nursingFormVisible = false);
      this.bindingVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      (this.destoryDeviceVisible = false),
        (this.braceletInfoVisible = false),
        (this.deviceResumeVisible = false),
        (this.nursingFormVisible = false);
      this.bindingVisible = false;

      this.onLoad();
    },
    viewRecord(row) {
      this.formRow = row;
      this.formModel = 'view';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      // getDeviceTypeList({ id: nursinghomeId }).then((res) => {
      //   this.deviceTypeIdList = res.data;
      // });
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);

          // getDeviceTypeList({ id: this.searchForm.nursinghomeId }).then((res) => {
          //   this.deviceTypeIdList = res.data;
          // });
          this.onLoad();
        }
      });
      getDictionary('nursinghome_device_online_status').then((res) => {
        this.onlineStatusList = res.data;
      });
      getDictionary('nursinghome_device_use_status').then((res) => {
        this.deviceStatuseList = res.data;
      });
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        getSmartDevicePage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
